export class Configuration
{
    //APIBaseUrl : string = "http://localhost:56109/";
    APIBaseUrl : string = "https://apieleven2.synergipartners.com/";
    PhenomURL : string = "http://phenom-test.synergipartners.com/"
    //PhenomURL : string = "http://localhost:17820/"
}


// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/app.config.ts